import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Image } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";

const InformacionContactoComponent = (props) => {
  return (
    <Fragment>
      <div className="informacion-contacto-contenedor">
        <div className="space-div"></div>
        <div className="informacion-contacto-logo">
          <div className="contacto-logo">
            <Image src="./assets/contacto/Estampilla-Jack.png" />
          </div>
        </div>
        <div className="informacion-contacto-contacto">
          <span className="contacto">
            {props.cambiarIdioma ? "contacto" : "contact"}
          </span>
          <div className="contacto-correo">
            <span>
              <a href="mailto:jack@lahabichuelamagica.com">
                jack@lahabichuelamagica.com
              </a>
            </span>
          </div>
          <div className="contacto-telefono">
            <span>
              <a href="tel:811 016 1396">811 016 1396</a>
            </span>
          </div>
        </div>
        <div className="informacion-contacto-ubicacion">
          <span className="ubicacion">
            {props.cambiarIdioma ? "ubicación" : "location"}
          </span>
          <div className="informacion-contacto-direccion">
            <a
              href="https://www.google.com/maps/place/La+Habichuela+M%C3%A1gica/@25.6226746,-100.2818763,17z/data=!3m1!4b1!4m5!3m4!1s0x8662bf730f672c07:0x2949df93ef07e2e3!8m2!3d25.6226746!4d-100.2796876"
              target="blank"
            >
              Blvd. Acapulco 4049 piso 2 Col. Las Brisas C.P 64780 Monterrey NL
            </a>
          </div>
        </div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </Fragment>
  );
};

InformacionContactoComponent.propTypes = {
  cambiarIdioma: PropTypes.bool,
};

export default InformacionContactoComponent;
